import React from "react";
import { Row, Col, InputNumber, Switch } from "antd";

// 越線 (cross-line) site-level tunables (spec "Tunables" table). Same
// EnableRow/FieldRow shape as ProtectionZoneConfig.jsx -- deliberately not
// abstracted into a shared component since this is the only other consumer
// and the two forms' fields diverge enough that a shared abstraction would
// need almost as many props as it saves.
const SectionHeader = () => (
  <Row gutter={16} className="mb-2">
    <Col span={10} />
    <Col span={4} className="text-center">
      <span className="text-muted small">偵測啟動</span>
    </Col>
    <Col span={10} />
  </Row>
);

const EnableRow = ({ label, description, enabledKey, fields, setField }) => (
  <Row gutter={16} className="mb-2 align-items-center">
    <Col span={10}>
      <label className="font-weight-bold">{label}</label>
      {description && <div className="text-muted small">{description}</div>}
    </Col>
    <Col span={4} className="text-center">
      <Switch
        checked={fields[enabledKey]}
        onChange={(v) => setField(enabledKey, v)}
      />
    </Col>
    <Col span={10} />
  </Row>
);

const FieldRow = ({
  label,
  description,
  fieldKey,
  min,
  max,
  step,
  unit,
  fields,
  setField,
}) => (
  <Row gutter={16} className="mb-2 align-items-center">
    <Col span={10}>
      <label>{label}</label>
      {description && <div className="text-muted small">{description}</div>}
    </Col>
    <Col span={4} />
    <Col span={10}>
      <InputNumber
        style={{ width: "100%" }}
        min={min}
        max={max}
        step={step}
        value={fields[fieldKey]}
        onChange={(v) => setField(fieldKey, v)}
        addonAfter={unit}
        placeholder="留空 = 系統預設"
      />
    </Col>
  </Row>
);

const TripwireConfig = ({ fields, setField }) => (
  <div className="pt-2">
    <SectionHeader />

    <EnableRow
      label="越線警報"
      description="關閉後，站台內所有越線警報線皆停用"
      enabledKey="tripwire_enabled"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="判定死區"
      description="貼近線的緩衝距離，避免在線上徘徊誤判"
      fieldKey="tripwire_band_m"
      min={0.1}
      max={10}
      step={0.1}
      unit="m"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="連續確認次數"
      description="需連續偵測到同一側幾次才確認越線"
      fieldKey="tripwire_confirm_samples"
      min={1}
      max={10}
      step={1}
      unit="次"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="最大間隔秒數"
      description="判定路徑中兩筆定位的最大允許時間差"
      fieldKey="tripwire_max_gap_s"
      min={3}
      max={600}
      step={1}
      unit="秒"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="冷卻秒數"
      description="同一對象同一警報線的重複警報間隔"
      fieldKey="tripwire_cooldown_seconds"
      min={0}
      max={86400}
      step={10}
      unit="秒"
      fields={fields}
      setField={setField}
    />
  </div>
);

export default TripwireConfig;
